import { useEffect, useRef } from "react";
import Chart from "chart.js/auto";

const HomeCharts = ({ label, color, data }) => {
    const canvasRef = useRef(null);
    const chartRef = useRef(null);

    useEffect(() => {
        const ctx = canvasRef.current.getContext("2d");
        if (chartRef.current) {
            chartRef.current.destroy();
        }

        const gradient = ctx.createLinearGradient(0, 0, 0, 300);
        gradient.addColorStop(0, color);
        gradient.addColorStop(1, color);

        chartRef.current = new Chart(ctx, {
            type: "bar",
            data: {
                labels: [
                    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
                ],
                datasets: [
                    {
                        label,
                        data,
                        backgroundColor: gradient,
                        borderColor: gradient,
                        borderRadius: 20,
                        borderWidth: 0,
                        maxBarThickness: 15
                    }
                ]
            },
            options: {
                maintainAspectRatio: false,
                barPercentage: 0.2,
                categoryPercentage: 0.8,
                plugins: {
                    legend: { display: false }
                },
                scales: {
                    y: { beginAtZero: true }
                }
            }
        });

        return () => {
            chartRef.current?.destroy();
        };
    }, [label, color, data]);

    return (
        <div style={{ height: "250px" }}>
            <canvas ref={canvasRef}></canvas>
        </div>
    )
}

export default HomeCharts